import React, { FC, useEffect, useState } from 'react';
import { FormControl, InputLabel, Select } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { TicketState } from '../../../../../../../interfaces/api/Ticket';
import useTicket from '../../../../../../../hooks/api/useTicket';

interface Props {
  value?: number;
  onChange: (value: number) => void;
}

const TicketStateSelect: FC<Props> = ({ onChange, value }) => {
  const [states, setStates] = useState<TicketState[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  const { getTicketStates } = useTicket();

  useEffect(() => {
    getTicketStates()
      .then((collection) => {
        setStates(collection.items);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  const handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const value = parseInt(event.target.value as string);
    onChange(value);
  };

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <FormControl variant='outlined' fullWidth>
      <InputLabel htmlFor='state-select'>État</InputLabel>
      <Select
        native
        label='État'
        value={value}
        onChange={handleChange}
        inputProps={{
          name: 'state',
          id: 'state-select',
        }}
      >
        {states.map((state, key) => (
          <option key={key} value={state.id}>
            {state.name}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default TicketStateSelect;
